<div class="filtered-results-toggle">
  <ul class="nav nav-tabs">
    <li [ngClass]="{ active: showUser }">
      <a data-toggle="tab" href="#home" (click)="showUsers()">
        Filtered Users({{ users.length }})
      </a>
    </li>
    <li [ngClass]="{ active: !showUser }">
      <a data-toggle="tab" href="#menu1" (click)="showIdeas()">
        Filtered Projects({{ ideas.length }})
      </a>
    </li>
  </ul>
  <div class="tab-content">
    <ng-container *ngIf="showUser">
      <app-filtered-users-preview [users]="users"></app-filtered-users-preview>
    </ng-container>
    <ng-container *ngIf="!showUser">
      <app-filtered-idea-list
        [ideaIdToSession]="ideaIdToSession"
        [ideas]="ideas"
        style="height: 100%; width: 100%"></app-filtered-idea-list>
    </ng-container>
  </div>
</div>
